<template>
  <div class="md-layout" ref="overdueSection">
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-blue">
        <h6 class="text-primary">Overdue Payments</h6>
      </md-card-header>

      <md-card-content>
        <div v-if="isLoading" class="text-center my-3">
          <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
        </div>

        <template v-if="!isLoading && visibleReportData.length">
          <router-link
            class="report-item md-layout"
            tag="div"
            v-for="report in visibleReportData"
            :key="report.id"
            :to="{
              name: 'Booking Profile',
              params: { id: report.BookingID }
            }"
          >
            <div class="md-layout-item md-size-70">
              <h6>
                {{ report.Customer }} | {{ report.Departure | formatDate }}
              </h6>
              <div class="md-caption">
                Due: {{ report.BalanceDue | formatDate }}
              </div>
            </div>

            <div class="md-layout-item md-size-30 text-right">
              <h6 class="money-text">
                Overdue: {{ currencySymbol(report.Currency)
                }}{{ report.Balance.toFixed(2) }}
              </h6>
            </div>

            <div class="md-layout-item md-size-70">
              <div class="md-caption">{{ report.Type }}: {{ report.Tour }}</div>
            </div>

            <div class="md-layout-item md-size-30 text-right">
              <div class="md-caption">
                Paid: {{ currencySymbol(report.Currency)
                }}{{ report.AmountPaid.toFixed(2) }}
              </div>
            </div>
          </router-link>

          <div class="mt-2">
            <md-button
              v-if="canSeeMore"
              class="md-primary md-dense"
              @click="seeMore"
            >
              See more
            </md-button>

            <md-button
              v-if="canSeeLess"
              class="md-primary md-dense"
              @click="seeLess"
            >
              See less
            </md-button>
          </div>
        </template>

        <div
          v-if="!isLoading && !reportData.length"
          class="empty-state text-center"
        >
          <h4>Nothing to Show</h4>
          <p>There's no data for this report.</p>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import reportApi from "@/services/api/report";

export default {
  data() {
    return {
      reportData: [],
      limit: 5,
      isLoading: false
    };
  },

  computed: {
    visibleReportData() {
      return this.reportData.slice(0, this.limit);
    },

    canSeeMore() {
      return this.limit < this.reportData.length;
    },

    canSeeLess() {
      return this.limit > 5;
    }
  },

  methods: {
    getReportData() {
      this.isLoading = true;
      reportApi
        .overdue()
        .then(response => {
          this.reportData = response.data.reportData;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    seeMore() {
      this.limit += 5;
      if (this.limit > this.reportData.length) {
        this.limit = this.reportData.length;
      }
    },

    seeLess() {
      this.limit = 5;
    },
    currencySymbol(code) {
      if (!code) return "";
      const symbols = {
        USD: "$",
        EUR: "€",
        GBP: "£"
      };
      return symbols[code.toUpperCase()] || code.toUpperCase();
    }
  },

  mounted() {
    this.getReportData();
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";

.report-item {
  padding: 3px 0px;
  border-bottom: 1px solid #d2d2d2;
  cursor: pointer;
}

.report-item h6 {
  margin: 0;
  font-weight: 500;
}

::v-deep .md-card-header h6 {
  margin: 0.5rem 0;
}

.status {
  color: $brand-warning;
}

.money-text {
  display: block;
  text-align: right;
  white-space: normal;
}
</style>
